import { apiTransformer } from 'utils';

export const refereeToApiTransformer = values => {
    return apiTransformer(values, ['qualification', 'profile']);
}
